// extracted by mini-css-extract-plugin
export default {"fullWidth":"profile_fullWidth__RNxrh","item":"profile_item__Y4LyY","label":"profile_label__FmQaa"};